import { FC } from 'react';

import { Dialog, DialogContent } from '@app/shared/ui/dialog';

import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';

import { RegisterQuiz } from './register-quiz';

export const RegisterQuizFullWidth: FC<{ onClose: () => void }> = ({ onClose }) => {
  const closeQuizHandler = () => {
    cookieUtils.remove(COOKIE_KEY.showQuiz);
    onClose();
  };

  return (
    <Dialog open>
      <DialogContent
        className="max-w-[30rem] bg-general_background_MIII_450_dark"
        customCloseIcon={null}
      >
        <div className="flex justify-center p-8">
          <RegisterQuiz isLoading={false} close={closeQuizHandler} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
